import { HistoryDetailsItem } from "@common/types/auditLog";
import {
    HistoryAccountDetailsRow,
    HistoryAccountLine,
} from "../views/historyAccountDetailsViewConfig";
import {
    CoaSubject,
    NOT_APPLICABLE_VALUE,
    IdentifierFormatter,
    resolveCoaSubject,
} from "./coaActivityValues";

interface BuildIdentityLineParams {
    log: HistoryDetailsItem;
    formatIdentifier: IdentifierFormatter;
    subject?: CoaSubject;
    label?: string | null;
}

export function buildIdentityLine({
    log,
    formatIdentifier,
    subject = resolveCoaSubject(log),
    label = null,
}: BuildIdentityLineParams): HistoryAccountLine {
    return {
        id: log.id,
        label,
        identifier: formatIdentifier(subject),
        identifierNote: null,
        groupPath: subject.groupPath,
        changedField: null,
        previous: NOT_APPLICABLE_VALUE,
        modified: NOT_APPLICABLE_VALUE,
    };
}

interface BuildRowParams {
    id: string;
    log: HistoryDetailsItem;
    lines: HistoryAccountLine[];
}

export function buildRow({
    id,
    log,
    lines,
}: BuildRowParams): HistoryAccountDetailsRow {
    return {
        id,
        logDate: log.createdAt,
        date: log.createdAt,
        entityId: log.entityId ?? null,
        lines,
    };
}

export type LogGroup = [HistoryDetailsItem, ...HistoryDetailsItem[]];

export function groupLogsBy(
    logs: HistoryDetailsItem[],
    getKey: (log: HistoryDetailsItem) => string,
): LogGroup[] {
    const groupsByKey = new Map<string, LogGroup>();
    for (const log of logs) {
        const key = getKey(log);
        const group = groupsByKey.get(key);
        if (group) {
            group.push(log);
        } else {
            groupsByKey.set(key, [log]);
        }
    }
    return Array.from(groupsByKey.values());
}
